import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogClose } from "../../../components/ui/dialog";
import { Formik } from "formik";
import { Button } from "../../../components/ui/button";
import { FormikInput, FormikSearchSelect, FormikTextArea } from "../../../components/formik-components";
import * as yup from "yup";
import Common from "../../../helper/common";
import { loader } from "react-global-loader";

import {
    ResultStatus,
} from "../../../constants/appConstant";
import { message } from "antd";

const AddRolesByClub = ({ open, setOpen, onClose, clubId }) => {

    const validationSchema = yup.object().shape({
        name: yup.string().required("Role name is required"),
    });

    const handleSubmit = async (values, actions) => {
        const payload = { ...values, clubId };

        if (!payload.clubId) {
            Common.AntDesignMessage.warning("Please select club first.");
            return;
        }

        const response = await Common.ApiService.getInstance().request(
            "AddRolesByClub",
            payload,
            "POST"
        );

        actions.setSubmitting(false);
        debugger
        if (response?.status === ResultStatus.Success) {
            onClose();
            setOpen(false);
            Common.showToast("Saved successfully", "Success", "success");
        } else {
            Common.showToast(response?.message || "Failed to save", "Error", "error");
        }
    };

    return (
        <Dialog open={open} onOpenChange={setOpen} >
            <DialogContent size="lg">
                <DialogHeader>
                    <DialogTitle>{"Add Role"}</DialogTitle>
                </DialogHeader>
                <Formik
                    initialValues={{ name: "", }}
                    validateOnChange={false}
                    validateOnBlur={false}
                    onSubmit={handleSubmit}
                >
                    {(formikProps) => (
                        <>
                            <div className="space-y-4 mt-4">
                                <FormikInput
                                    formikProps={formikProps}
                                    name="name"
                                    label="Role Name"
                                    placeholder="Enter role name."
                                />
                            </div>
                            <DialogFooter className="mt-6">
                                <DialogClose asChild>
                                    <Button variant="outline">Cancel</Button>
                                </DialogClose>
                                <Button
                                    type="button"
                                    onClick={formikProps.handleSubmit}
                                    disabled={formikProps.isSubmitting}
                                >
                                    {formikProps.isSubmitting ? "Saving..." : "Add"}
                                </Button>
                            </DialogFooter>
                        </>
                    )}
                </Formik>
            </DialogContent>
        </Dialog>
    );
};

export default AddRolesByClub;